import * as React from "react";
const SvgIcChevronUp = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="m13.826 13.334-3.825-3.825-3.825 3.825-1.175-1.184 5-5 5 5-1.175 1.184Z" /></svg>;
export default SvgIcChevronUp;